module.exports = __webpack_public_path__ + "819234f7fccab01afb6f6cf2985d27ff.jpg";